import { action } from 'typesafe-actions';

import { RecordingTypeKeys, RecordingContextValues, TranscodedInfo } from './types';

export const enactRecording = (explanationContext: RecordingContextValues) => {
    return action(RecordingTypeKeys.ENACT_RECORDING, explanationContext);
};

export const setRecorderIntervalId = (recorderIntervalId: number) => {
    return action(RecordingTypeKeys.SET_RECORDER_INTERVAL_ID, recorderIntervalId);
};

export const incrementRecordedTime = () => {
    return action(RecordingTypeKeys.INCREMENT_RECORDED_TIME);
};

export const startTranscodingOfRecordedAudio = (waitForWorkspace: boolean) => {
    return action(RecordingTypeKeys.INITIATE_TRANSCODING_OF_RECORDED_AUDIO, waitForWorkspace);
};

export const saveRecordedAudio = () => {
    return action(RecordingTypeKeys.SAVE_RECORDED_AUDIO);
};

export const saveRecordedAudioButWaitForWorkspace = () => {
    return action(RecordingTypeKeys.SAVE_RECORDED_AUDIO_BUT_WAIT_FOR_WORKSPACE);
};

export const saveRecordedAudioButWaitForParty = () => {
    return action(RecordingTypeKeys.SAVE_RECORDED_AUDIO_BUT_WAIT_FOR_PARTY);
};

export const saveRecordedAudioSuccess = () => {
    return action(RecordingTypeKeys.SAVE_RECORDED_AUDIO_SUCCESS);
};

export const saveRecordedAudioFailed = () => {
    return action(RecordingTypeKeys.SAVE_RECORDED_AUDIO_FAILED);
};

export const rejectRecordingPermission = () => {
    return action(RecordingTypeKeys.REJECT_RECORDING_PERMISSION);
};

export const grantRecordingPermission = () => {
    return action(RecordingTypeKeys.GRANT_RECORDING_PERMISSION);
};

export const pauseRecording = () => {
    return action(RecordingTypeKeys.PAUSE_RECORDING);
};

export const resumeRecording = () => {
    return action(RecordingTypeKeys.RESUME_RECORDING);
};

export const setWorkspaceRestored = () => {
    return action(RecordingTypeKeys.SET_WORKSPACE_RESTORED);
};

export const askCancelRecording = () => {
    return action(RecordingTypeKeys.ASK_CANCEL_RECORDING);
};

export const cancelExplanationRecording = () => {
    return action(RecordingTypeKeys.CANCEL_RECORDING);
};

export const desistCancelExplanationRecording = () => {
    return action(RecordingTypeKeys.DESIST_CANCEL_RECORDING);
};

export const closeRecording = () => {
    return action(RecordingTypeKeys.CLOSE_RECORDING);
};

export const askRedoRecording = () => {
    return action(RecordingTypeKeys.ASK_REDO_RECORDING);
};

export const redoExplanationRecording = () => {
    return action(RecordingTypeKeys.REDO_RECORDING);
};

export const desistRedoExplanationRecording = () => {
    return action(RecordingTypeKeys.DESIST_REDO_RECORDING);
};

export const reenactRecording = () => {
    return action(RecordingTypeKeys.REENACT_RECORDING);
};

export const askFilenameForRecording = (payload: TranscodedInfo) => {
    return action(RecordingTypeKeys.ASK_FILENAME_FOR_RECORDING, payload);
};

export const setFilenameForRecording = (filename: string) => {
    return action(RecordingTypeKeys.SET_FILENAME, filename);
};

export const retrySaving = (waitForWorkspace: boolean) => {
    return action(RecordingTypeKeys.RETRY_SAVING, waitForWorkspace);
};
